const costAdditionScope = {
  Global: "COST_ADDITIONS",
  Bio: "BIO_COST_ADDITIONS",
  Temperature: "TEMPERATURE",
  Customer: "CUSTOMER",
};

export { costAdditionScope };
